import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { AbsenceDayCell } from './AbsenceDayCell';
import { decimalFormatter } from '../../components/Table/utility';
import { forwardRef } from 'react';
import { DayHeaderCell } from '../../components/Cells/CalendarTable/DayHeaderCell';

const AbsencesTable = forwardRef((props, ref) => {
  const {
    dayHeaders,
    data,
    isReadOnly,
    isEmbeddedInWorklog,
    onAddClick,
    onEditClick,
    onDeleteClick,
    onScroll,
    isMonthClosed,
  } = props;

  return (
    <TableContainer component={Paper} onScroll={onScroll} ref={ref}>
      <Table
        stickyHeader
        className={`month-table ${!isEmbeddedInWorklog ? 'absence-table' : ''}`}
      >
        <TableHead>
          <TableRow>
            <TableCell            >
              {isEmbeddedInWorklog ? 'Assenze' : 'Utente'}
            </TableCell>
            <TableCell
              style={
                !isEmbeddedInWorklog
                  ? { width: 70, minWidth: 70, maxWidth: 70 }
                  : undefined
              }
            >
              {isEmbeddedInWorklog ? 'Ore' : 'GG'}
            </TableCell>
            {!isEmbeddedInWorklog ? (
              <TableCell style={{ width: 70, minWidth: 70, maxWidth: 70 }}>
                Ore
              </TableCell>
            ) : null}
            {dayHeaders.map((header) => (
              <DayHeaderCell
                day={header.day}
                isWeekEnd={header.weekEnd}
                isHoliday={header.isHolidays}
                isToday={header.isToday}
                key={header.day.format('DD')}
              />
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((userData) => (
            <TableRow key={userData.userId}>
              <TableCell
                style={
                  !isEmbeddedInWorklog
                    ? { width: 137, minWidth: 137, maxWidth: 137 }
                    : undefined
                }
              >
                {isEmbeddedInWorklog ? '' : userData.userFullName}
              </TableCell>
              <TableCell
                style={
                  !isEmbeddedInWorklog
                    ? { width: 70, minWidth: 70, maxWidth: 70 }
                    : undefined
                }
              >
                {decimalFormatter.format(
                  isEmbeddedInWorklog
                    ? userData.totalHours
                    : userData.totalHours / userData.userWorktime
                )}
              </TableCell>
              {!isEmbeddedInWorklog ? (
                <TableCell style={{ width: 70, minWidth: 70, maxWidth: 70 }}>
                  {decimalFormatter.format(userData.totalHours)}
                </TableCell>
              ) : null}
              {dayHeaders.map((header) => {
                const date = header.day.format('YYYY-MM-DD');
                const cellData = userData.items.find((i) => i.date === date);
                return (
                  <AbsenceDayCell
                    data={cellData}
                    date={date}
                    isReadOnly={isReadOnly}
                    isEmbeddedInWorklog={isEmbeddedInWorklog}
                    isMonthClosed={isMonthClosed}
                    isWeekEnd={header.weekEnd}
                    isHoliday={header.isHolidays}
                    isToday={header.isToday}
                    onAddClick={onAddClick}
                    onEditClick={onEditClick}
                    onDeleteClick={onDeleteClick}
                    key={date}
                    userWorktime={userData.userWorktime}
                  />
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
});

AbsencesTable.defaultProps = {
  dayHeaders: [],
  data: [],
  isReadOnly: false,
  isEmbeddedInWorklog: false,
  isMonthClosed: false,
  onAddClick: () => {},
  onEditClick: () => {},
  onDeleteClick: () => {},
  onScroll: () => {},
};

AbsencesTable.propTypes = {
  dayHeaders: PropTypes.instanceOf(Array),
  data: PropTypes.instanceOf(Array),
  isReadOnly: PropTypes.bool,
  isEmbeddedInWorklog: PropTypes.bool,
  isMonthClosed: PropTypes.bool,
  onAddClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onScroll: PropTypes.func,
};

AbsencesTable.displayName = 'AbsencesTable';
export default AbsencesTable;
